import React, { useCallback, useMemo } from 'react';
import { FieldError } from 'react-hook-form';
import Select, { SingleValue } from 'react-select';
import { SText } from 'src/components/SText';
import { FormsErrorParser } from 'src/containers/errors';
import { NullableValue, SimpleSelectData, SimpleSelectDataItem } from 'src/types';

export type SelectProps = {
  testID?: string;
  data: SimpleSelectData;
  style?: React.CSSProperties | undefined;
  selectedId?: NullableValue;
  error?: FieldError | undefined;
  onChange?: (value: any) => void;
  placeholder?: string;
  label?: string;
  showUpLabel?: boolean;
  isMulti?: boolean;
};

export const SelectSimple: React.FC<SelectProps> = ({
  onChange,
  error,
  selectedId,
  showUpLabel,
  label,
  data,
  style,
  isMulti,
  placeholder,
}) => {
  const interactiveClasses = error ? 'border-red-500' : 'border-gray-400';

  const onChangeHandler = useCallback(
    (newValue: SingleValue<SimpleSelectDataItem>) => {
      if (newValue instanceof Array) {
        onChange && onChange(newValue.map((item) => item.value));
        return;
      }

      newValue && onChange && onChange(newValue.value);
    },
    [onChange],
  );

  const selectedValues = useMemo(() => {
    if (selectedId) {
      if (Array.isArray(selectedId)) {
        return data.filter((item) => selectedId.includes(item.value));
      }

      const selected = data.find((item) => item.value === selectedId);
      return selected ? [selected] : [];
    }
    return [];
  }, [selectedId, data]);

  return (
    <div className="w-full">
      {showUpLabel && (
        <SText
          classNames="block text-xl text-primary font-semibold my-1 text-left flex w-full"
          label={label ?? placeholder ?? ''}
        />
      )}

      <Select
        className={`px-4 py-2 rounded-md  shadow-sc text-primary ${interactiveClasses} w-full border py-3 my-2 px-2`}
        onChange={onChangeHandler as unknown as any}
        options={data}
        styles={style as unknown as any}
        isMulti={isMulti}
        value={selectedValues}
      />
      <FormsErrorParser error={error} />
    </div>
  );
};
